/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProcessInstanceActivityLogDto } from '../../models/process-instance-activity-log-dto';

export interface AutomatedProcessGetProcessInstanceActivityLog$Params {
  processInstanceId: string;
}

export function automatedProcessGetProcessInstanceActivityLog(http: HttpClient, rootUrl: string, params: AutomatedProcessGetProcessInstanceActivityLog$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProcessInstanceActivityLogDto>>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessGetProcessInstanceActivityLog.PATH, 'get');
  if (params) {
    rb.path('processInstanceId', params.processInstanceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProcessInstanceActivityLogDto>>;
    })
  );
}

automatedProcessGetProcessInstanceActivityLog.PATH = '/automated-process/process-instance/{processInstanceId}/activity-log';